import React, { useEffect, useState } from 'react'
import { Datagrid, List, TextField, DateField, Filter, SelectInput, TextInput, FunctionField } from 'ra-ui-materialui'
import { makeStyles } from '@material-ui/core'
import ColoredLeadPropertyStatusField from '../../components/ColoredLeadPropertyStatusField'
import { Chip } from '@material-ui/core'
import authProvider from '../../utils/authProvider'

const ListLeadProperty = (props) => {
  const useStyles = makeStyles({
    rowCell: {
      maxWidth: '140px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      padding: '10px',
      '& span': {
        fontSize: '0.8rem',
      },
    },
  })

  const [email, setEmail] = useState(null)
  useEffect(() => {
    authProvider.getIdentity().then((r) => {
      setEmail(r.email)
    })
  })

  const classes = useStyles()
  const status = [
    { id: 'open', name: 'Open' },
    { id: 'working', name: 'Working' },
    { id: 'closed_converted', name: 'Closed Converted' },
    { id: 'closed_not_converted', name: 'Closed Not Converted' },
    { id: 'cancelled', name: 'Cancelled' },
  ]

  const LeadPropertyFilter = (props) => (
    <Filter {...props}>
      <QuickFilter source="worked_by" label="My Leads" defaultValue={email} />
      <TextInput label="ID" source="id" />
      <TextInput label="MyPhoner id" source="my_phoner_id" />
      <TextInput label="Property id" source="property_id" />
      <TextInput label="Landlord id" source="landlord_id" />
      <SelectInput choices={status} source="status" />
    </Filter>
  )

  const useQuickFilterStyles = makeStyles((theme) => ({
    chip: {
      marginBottom: theme.spacing(1),
    },
  }))
  const QuickFilter = ({ label }) => {
    const classes = useQuickFilterStyles()
    return <Chip className={classes.chip} label={label} />
  }

  return (
    <List {...props} filters={<LeadPropertyFilter />} filterDefaultValues={{ worked_by: email }} bulkActionButtons={false}>
      <Datagrid classes={{ rowCell: classes.rowCell }} rowClick="edit" optimized>
        <TextField label="Id" source="id" sortable={false} />
        <TextField label="MyPhoner id" source="my_phoner_id" sortable={false} />
        <TextField label="Property id" source="property_id" sortable={false} />
        <TextField label="Landlord id " source="landlord_id" sortable={false} />
        <FunctionField
          label="Status"
          source="status"
          sortable={false}
          render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
        />
        <TextField label="Phone" source="phone_no" sortable={false} />
        <TextField label="Email" source="email" sortable={false} />
        <TextField label="Worked by" source="worked_by" sortable={false} />
        <TextField label="Pipedrive Owner" source="pipedrive_owner_email" sortable={false} />
        <DateField label="Created at" source="created_at" sortable={false} />
      </Datagrid>
    </List>
  )
}

export default ListLeadProperty
